{
  "actionbar.actions": "Acciones",
  "actionbar.actionsAvailable": "Acciones disponibles.",
  "actionbar.clearSelection": "Borrar selección",
  "actionbar.selected": "{count, plural, =0 {Ninguno seleccionado} other {# seleccionados}}",
  "actionbar.selectedAll": "Todos seleccionados",
  "breadcrumbs.more": "Más elementos",
  "button.pending": "pendiente",
  "combobox.noResults": "Sin resultados",
  "contextualhelp.help": "Ayuda",
  "contextualhelp.info": "Información",
  "dialog.alert": "Alerta",
  "dialog.dismiss": "Descartar",
  "dropzone.replaceMessage": "Suelte el archivo para reemplazar",
  "inlinealert.informative": "Información",
  "inlinealert.negative": "Error",
  "inlinealert.notice": "Advertencia",
  "inlinealert.positive": "Éxito",
  "label.(optional)": "(opcional)",
  "label.(required)": "(obligatorio)",
  "menu.moreActions": "Más acciones",
  "notificationbadge.indicatorOnly": "Nueva actividad",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Seleccione…",
  "slider.maximum": "Máximo",
  "slider.minimum": "Mínimo",
  "table.loading": "Cargando…",
  "table.loadingMore": "Cargando más…",
  "table.resizeColumn": "Cambiar el tamaño de la columna",
  "table.sortAscending": "Orden ascendente",
  "table.sortDescending": "Orden descendente",
  "tag.actions": "Acciones",
  "tag.hideButtonLabel": "Mostrar menos",
  "tag.noTags": "Ninguno",
  "tag.showAllButtonLabel": "Mostrar todo ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
